import { create } from "zustand";
import { createJSONStorage, devtools, persist } from "zustand/middleware";
import { WithTypeContaining } from "../../../types/utilityTypes";

export type PersonalDetailsState = {
  firstName: string;
  firstNameTransliterated: string;
  lastName: string;
  lastNameTransliterated: string;
  middleInitial: string;
  mothersMaidenName: string;
  gender: string;
  spouseFirstName: string;
  spouseMiddleName: string;
  spouseLastName: string;
  dateOfBirth: string;
  placeOfBirthCountry: string;
  placeOfBirthProvince: string;
  placeOfBirthCity: string;
  ethnicity: string;
};

interface PersonalDetailsAction {
  setPersonalDetails: (
    personalInfoValues: WithTypeContaining<PersonalDetailsState>
  ) => void;
  setFirstAndLastName: (
    firstName: string | undefined,
    lastName: string | undefined
  ) => void;
  reset: () => void;
}

const initialState: PersonalDetailsState = {
  firstName: "",
  firstNameTransliterated: "",
  lastName: "",
  lastNameTransliterated: "",
  middleInitial: "",
  mothersMaidenName: "",
  gender: "",
  spouseFirstName: "",
  spouseMiddleName: "",
  spouseLastName: "",
  dateOfBirth: "",
  placeOfBirthCountry: "",
  placeOfBirthProvince: "",
  placeOfBirthCity: "",
  ethnicity: "",
};

export const usePersonalDetailsStore = create<
  PersonalDetailsState & PersonalDetailsAction
>()(
  devtools(
    persist(
      (set) => ({
        ...initialState,
        setPersonalDetails: (personalInfoValues) => {
          set(createPersonalDetailsFromForm(personalInfoValues));
        },
        setFirstAndLastName: (firstName, lastName) => {
          if (firstName) {
            set({ firstName });
          }
          if (lastName) {
            set({ lastName });
          }
        },
        reset: () => set(initialState),
      }),
      {
        name: "personal-details-storage",
        storage: createJSONStorage(() => sessionStorage),
      }
    )
  )
);

const createPersonalDetailsFromForm = ({
  firstName,
  firstNameTransliterated,
  lastName,
  lastNameTransliterated,
  mothersMaidenName,
  middleInitial,
  gender,
  spouseFirstName,
  spouseMiddleName,
  spouseLastName,
  dateOfBirth,
  placeOfBirthCountry,
  placeOfBirthProvince,
  placeOfBirthCity,
  ethnicity,
}: WithTypeContaining<PersonalDetailsState>): PersonalDetailsState => ({
  firstName,
  firstNameTransliterated,
  lastName,
  lastNameTransliterated,
  mothersMaidenName,
  middleInitial,
  gender,
  spouseFirstName,
  spouseMiddleName,
  spouseLastName,
  dateOfBirth,
  placeOfBirthCountry,
  placeOfBirthProvince,
  placeOfBirthCity,
  ethnicity,
});
